import MultipleWidgetContainer from './MultipleWidgetContainer.component';
export default MultipleWidgetContainer;



// WEBPACK FOOTER //
// ./fe/web-career/src/js/web/MultipleWidgetContainer/index.js